import { createAction, props } from "@ngrx/store";
import { MsvTransaction, MsvTransactionResponse } from "../models/master-status-view/TransactionsResponse";
import { ServiceError } from "../models/shared/ServiceError";
import { MasterTransactionsTableColumn } from "../../shared/types/MasterTransactionsTableColumn";
import { transactionTypes, ViewTypes } from "../../shared/utilities/Constants";

export const refreshMaster = createAction(
    '[Master Status View Header] Refresh Master Account Data',
    props<{ masterAccountId: string }>()
);

export const callTransactionsSuccess = createAction(
    '[Master Status View Page - API] Transactions Loaded Successfully',
    props<MsvTransactionResponse>()
)

export const callTransactionsFailure = createAction(
    '[Master Status View Page - API] Transactions NOT Loaded',
    props<ServiceError>()
)

export const getMasterTransactionsList = createAction(
    '[Master Status View] Get the list of master status view transactions',
)

export const setCurrentViewedTransaction = createAction(
  '[Master Status View - Master Transactions Table] - Map cashiering transaction',
  props<{ transaction: MasterTransactionsTableColumn }>()
);

export const getBookmarkedAccounts = createAction(
    '[Master Status View] Retrieve bookmarked accounts',
    props<{isBookmarkFilterOn: boolean}>()
);

export const callBookmarkedAccountsSuccess = createAction(
    '[Master Status View Page - API] Bookmarked Accounts Loaded Successfully',
    props<MsvTransactionResponse>()
);

export const callMsvInternalTransferInquiry = createAction(
  '[Master Status View - View Page] Call internal transfer inquiry',
  props<{ payload: MsvTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const callMsvCheckInquiry = createAction(
  '[Master Status View - View Page] Call check inquiry',
  props<{ payload: MsvTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const callMsvAchInquiry = createAction(
  '[Master Status View - View Page] Call ach inquiry',
  props<{ payload: MsvTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const callMsvWireInquiry = createAction(
  '[Master Status View - View Page] Call wire inquiry',
  props<{ payload: MsvTransaction, viewType: ViewTypes, transactionType: transactionTypes, resourceVersion: string }>()
);
